import React from "react";

const getVideoStyle = (objectFit: string) => ({
  position: "fixed" as const,
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  zIndex: -100,
  objectFit: (objectFit === "contain" ? "contain" : "cover") as "cover" | "contain",
  backgroundColor: "rgb(0, 0, 0)",
});

function isVideoFile(filename: string) {
  const videoExtensions = [".mp4", ".webm", ".ogg", ".mov"];
  const extension = filename.slice(filename.lastIndexOf(".")).toLowerCase();
  return videoExtensions.includes(extension);
}

export default function AnimatedBackground({ body }) {
  if (body) {
    const bodyStyle = window.getComputedStyle(body);
    const urlRegex = /url\(['"]?([^'"]*)['"]?\)/;
    const matches = bodyStyle.background.match(urlRegex);
    const url = matches?.[1];

    if (url) {
      const isVideo = isVideoFile(url);

      if (isVideo) {
        const backgroundSize = bodyStyle.backgroundSize || "cover";
        const style = getVideoStyle(backgroundSize);
        return (
          <video style={style} autoPlay playsInline muted poster="" loop controls={false} preload="auto">
            <source src={url} type="video/mp4" />
            <source src={url} type="video/webm" />
          </video>
        );
      }
    }
  }

  return null;
}
